import { ComponentType } from "react";
import { List, Calendar, Phone, Mail } from "react-feather";

class Type {

	public static ACTION_ITEM = new Type(1, "Action Item", "#ab47bc", List);
	public static APPOINTMENT = new Type(2, "Appointment", "#398ad6", Calendar);
	public static CALL_BACK = new Type(3, "Call Back", "#4dcdac", Phone);
	public static EMAIL = new Type(4, "Email", "#fa8a33", Mail);

	private constructor(
		public readonly id: number,
		public readonly name: string,
		public readonly backgroundColor: string,
		public readonly icon: ComponentType<{ size?: number | string }>,
	) {
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id: number) {
		return this.values().find(value => value.id === id);
	}
}

export { Type as TaskType };
